<template>
  <div class="blank_layout">
    <router-view></router-view>
    <cookie-law theme="base" buttonText="Rozumiem">
      <div slot="message">Strona nie wykorzystuje technologii plików cookies.</div>
    </cookie-law>
  </div>
</template>
<script>
import CookieLaw from 'vue-cookie-law';

export default {
  components: {
    CookieLaw
  }
}
</script>